export default __webpack_public_path__ + "static/media/cover.50017a45.jpg";